import { useQuery } from '@tanstack/react-query';

import { useAuthContext } from '@cognite/e2e-auth';

import { QueryKeys } from '../../../../utils/queryKeys';

export const useGroupsQuery = () => {
  const { client } = useAuthContext();

  const { data } = useQuery({
    queryKey: [QueryKeys.GROUPS],
    queryFn: async () => {
      return client.groups.list({ all: true });
    },
    meta: { error: { captureError: true, level: 'fatal' } },
  });
  return {
    data: data,
  };
};
